/**
 * Skeleton Loader Components
 * Provides loading states for different content types
 */

export function MetricSkeleton() {
  return (
    <div style={styles.container}>
      <div style={styles.label} />
      <div style={styles.metric} />
      <div style={styles.context}>
        <div style={styles.contextItem} />
        <div style={styles.contextItem} />
      </div>
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader} />
      <div style={styles.cardContent}>
        <div style={styles.cardLine} />
        <div style={styles.cardLine} />
        <div style={styles.cardLineShort} />
      </div>
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader} />
      <div style={styles.chartArea}>
        <div style={styles.chartBar} />
        <div style={styles.chartBar} />
        <div style={styles.chartBar} />
        <div style={styles.chartBar} />
        <div style={styles.chartBar} />
      </div>
    </div>
  );
}

export function TableSkeleton() {
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader} />
      <div style={styles.table}>
        <div style={styles.tableRow} />
        <div style={styles.tableRow} />
        <div style={styles.tableRow} />
        <div style={styles.tableRow} />
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
  },
  label: {
    width: '200px',
    height: '12px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    marginBottom: 'var(--spacing-2)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
  metric: {
    width: '300px',
    height: '48px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    marginBottom: 'var(--spacing-4)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
  context: {
    display: 'flex',
    gap: 'var(--spacing-4)',
    flexWrap: 'wrap',
  },
  contextItem: {
    width: '150px',
    height: '18px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
  card: {
    backgroundColor: 'var(--color-bg-primary)',
    border: '1px solid var(--color-border-light)',
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--spacing-5)',
    boxShadow: 'var(--shadow-md)',
  },
  cardHeader: {
    width: '180px',
    height: '20px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    marginBottom: 'var(--spacing-4)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-2)',
  },
  cardLine: {
    width: '100%',
    height: '16px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
  cardLineShort: {
    width: '60%',
    height: '16px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
  chartArea: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 'var(--spacing-2)',
    height: '200px',
    marginTop: 'var(--spacing-4)',
  },
  chartBar: {
    flex: 1,
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm) var(--radius-sm) 0 0',
    animation: 'skeletonPulse 2s ease-in-out infinite',
    minHeight: '40px',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-2)',
  },
  tableRow: {
    width: '100%',
    height: '48px',
    backgroundColor: 'var(--color-bg-tertiary)',
    borderRadius: 'var(--radius-sm)',
    animation: 'skeletonPulse 2s ease-in-out infinite',
  },
};

// Add skeleton pulse animation if not already present
if (!document.getElementById('skeleton-animations')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'skeleton-animations';
  styleSheet.textContent = `
    @keyframes skeletonPulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.5;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      @keyframes skeletonPulse {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0.8;
        }
      }
    }
  `;
  document.head.appendChild(styleSheet);
}

